import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
// import JwtService from "../services/jwt.service";

window.env = 'prod';

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {

   init(env) {
      Vue.use(VueAxios, axios);
      (env ? window.env = env : window.env);
   },

   setPuppeteerAsBaseUrl() {
      Vue.axios.defaults.baseURL = (window.env === 'prod' ? "https://sp-puppeteer.herokuapp.com" : "http://localhost:8000");
   },

   setWeb3AsBaseUrl() {
      Vue.axios.defaults.baseURL = (window.env === 'prod' ? "https://sp-web3.herokuapp.com" : "http://localhost:62700");
   },

   setPdfApiAsBaseUrl() {
      Vue.axios.defaults.baseURL = (window.env === 'prod' ? "https://sp-pdf-server.herokuapp.com" : "http://screenproof.server.test");
   },

   setPdfDownloadAsBaseUrlNew(resource) {
      return new Promise((resolve, reject) => {
         let baseUrl = (window.env === 'prod' ? "https://sp-pdf-server.herokuapp.com/pdf/download" : "http://screenproof.server.test/pdf/download");
         axios({
            url: `${baseUrl}${resource}`,
            method: 'get',
            headers: {},
            responseType: 'arraybuffer',
         })
             .then(data => {
                resolve(data.data);
             })
             .catch(error => {
                reject(error.toString());
             });
      });
   },


   /**
    * Send the GET HTTP request
    * @param resource
    * @returns {*}
    */
   get(resource) {
      return Vue.axios.get(`${resource}`);
   },


   /**
    * Set the POST HTTP request
    * @param resource
    * @param params
    * @returns {*}
    */
   post(resource, params) {
      return Vue.axios.post(`${resource}`, params);
   },


   /**
    * Set the default HTTP request headers
    */
   // setHeader() {
   //    Vue.axios.defaults.headers.common[
   //        "Authorization"
   //        ] = `Token ${JwtService.getToken()}`;
   // },
   //
   // query(resource, params) {
   //    return Vue.axios.get(resource, params).catch(error => {
   //       // console.log(error);
   //       throw new Error(`[KT] ApiService ${error}`);
   //    });
   // },
   //
   //
   //
   // /**
   //  * Send the UPDATE HTTP request
   //  * @param resource
   //  * @param slug
   //  * @param params
   //  * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   //  */
   // update(resource, slug, params) {
   //    return Vue.axios.put(`${resource}/${slug}`, params);
   // },
   //
   // /**
   //  * Send the PUT HTTP request
   //  * @param resource
   //  * @param params
   //  * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   //  */
   // put(resource, params) {
   //    return Vue.axios.put(`${resource}`, params);
   // },
   //
   // /**
   //  * Send the DELETE HTTP request
   //  * @param resource
   //  * @returns {*}
   //  */
   // delete(resource) {
   //    return Vue.axios.delete(resource).catch(error => {
   //       throw new Error(`[RWV] ApiService ${error}`);
   //    });
   // }
};

export default ApiService;
